import React from 'react';

const AboutUs = () => (
  <section id="about" className="about-us">
    <h2>About Us</h2>
    <p>
      “All the great men have humble beginnings” — a saying that perfectly describes Mr. S.P. Rao, Director and Chief Coach of SP Rao Technologies.
    </p>
    <p>
      Founded in 2007, SP Rao Technologies has grown into a premier center for SAP ABAP training under Mr. Rao’s dynamic leadership. A self-made professional, he overcame numerous challenges with unwavering determination and patience.
    </p>
    <p>
      With over 18 years of hands-on experience, Mr.SP Rao has trained thousands of students, achieving an 80% placement rate. His corporate training expertise and commitment to student success have made SP Rao Technologies a trusted name in SAP education.
    </p>
    <p>
      To date, the institute has produced over 11000 qualified ABAP professionals, shaping the future of enterprise technology.
    </p>
    <p className="success-rate">
          🎯 Our proud achievement: <strong>80% Success & Placement Rate</strong> across all trained students.
    </p>

  </section>
);

export default AboutUs;